import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Detecção Electron — scrollbar customizada apenas no app desktop
if (navigator.userAgent.toLowerCase().includes('electron')) {
  document.documentElement.classList.add('is-electron');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
